import work from 'webworkify-webpack'

// const myworker = work(require.resolve('../plugins/worker_prepare_excel_data.js'));

export const exportExcelMixin =  {
    data(){
        return{
            myworker: work(require.resolve('../plugins/worker_prepare_excel_data.js')),
            // periods:[
            //   {"title":"Today", "value":"currentDate"},
            //   {"title":"This Month", "value":"month"},
            //   {"title":"This Quarter", "value":"quarter"},
            //   {"title":"This Financial Year", "value":"year"},
            //   {"title":"Monthly", "value":"M"},
            //   {"title":"Quarterly", "value":"Q"}
            // ]
            periods:[
              {"title":"Today", "value":"currentDate"},
              {"title":"Yesterday", "value":"previousDate"},
              {"title":"This Month", "value":"month"},
              {"title":"Previous Month", "value":"previousMonth"},
              {"title":"Select Month", "value":"M"},
              {"title":"This Quarter", "value":"quarter"},
              {"title":"Select Quarter", "value":"Q"},
              {"title":"This Fiscal Year", "value":"year"},
              {"title":"Select Fiscal Year", "value":"FY"},
              {"title":"All Time", "value":"alltime"},
              {"title":"Custom", "value":null},
            ],
            selectedStartDate:null,
            selectedEndDate:null,
            infoSnackbar:false
        }
    },

    methods: {

        fn_openDialogCustomDates: function(){
            this.selectedStartDate = this.selectionItems.startDate;
            this.selectedEndDate = this.selectionItems.endDate;
            this.fn_openDialogWeb('web', 'CustomPeriod', 'ref_dialogCustomPeriod');
            // this.$refs['ref_dialogCustomPeriod'].openDialogWeb();
        },
        
        fn_openDatePicker: function (type, date) {
            let self = this;
            this.dateType = type;
            this.selectedDate = date ? date : new Date();
            setTimeout(function () {
                self.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePicker');
                // self.$refs['ref_dialogDatePicker'].openDialogWeb();
            })
        },

        fn_updateDate: function (value) {
            if(this.dateType=="start"){
                this.selectedStartDate = value;
            }
            else{
                this.selectedEndDate = value;
            }

            this.fn_closeDialog();
        },


        fn_updateCustomDates: function(){
            this.selectionItems.startDate = this.selectedStartDate;
            this.selectionItems.endDate = this.selectedEndDate;
            this.selectionItems.selectedPeriod = "Custom";
            localStorage.setItem('transaction_filter', JSON.stringify(this.selectionItems));
            this.fn_closeDialog();
            this.fn_searchItem();
        },

        fn_getReportData: function(){
            let self = this;
            this.$root.fn_checkStoragePermission(function(){
                self.showLoading("Downloading Summary...");
                let filterObject = {};
                filterObject.reportId = 11;
                filterObject.startDate = self.$moment(self.selectionItems.startDate).startOf('day'); //new Date(self.selectionItems.startDate);
                filterObject.endDate = self.$moment(self.selectionItems.endDate).endOf('day');

                filterObject.startDate = self.$root.fn_getLocalDateFormat(filterObject.startDate);
                filterObject.endDate = self.$root.fn_getLocalDateFormat(filterObject.endDate);

                filterObject.transactionListId = [self.settings.transactionTypeId];
                self.selectionItems.typeFormId ? filterObject.transactionTypeFormIds = [self.selectionItems.typeFormId] : '';
                filterObject.search = self.searchValue;

                if(filterObject.transactionListId == 20005){
                    filterObject.filterType = self.selectionItems.filterType;
                }

                console.log(JSON.stringify(filterObject));

                let itemId = null;
                self.getReportData('Report', itemId, filterObject,{

                    onSuccess: function(response){
                        console.log(response);
                        let reportData = JSON.parse(response);

                        // setting up party column as cash in case of cash expense
                        if(self.settings.transactionTypeId == 20005){
                            for(let i=0; i<reportData.data.detailRows.length; i++){
                                if(!reportData.data.detailRows[i].cols.party){
                                    reportData.data.detailRows[i].cols.party = "Supplier not applicable";
                                }
                            }
                        }

                        self.fn_processDataForExcel(reportData);
                    }, 
                    onError: function(error){
                        console.log(error);
                        self.hideLoading();
                    }

                });
            })
        },

        fn_processDataForExcel: function(reportData){
            let startDate = this.$moment(this.selectionItems.startDate).format('DD-MMM-YYYY');
            let endDate = this.$moment(this.selectionItems.endDate).format('DD-MMM-YYYY');  

            let dataObj = {};

            dataObj = {"reportDataObject":{}}
            dataObj.reportDataObject = {};
            dataObj.reportDataObject.reportData = {};
            dataObj.reportDataObject.reportData = reportData.data;
            dataObj.reportDataObject.reportData.headerRow = {"transactionListId":"Voucher","transactionDate":"Date","mergeTransactionNumber":"Number","party":"Party","amount":"Amount","notes":"Notes"}

            dataObj.otherData = {};
            dataObj.otherData.headerRow1 = this.$root.CurrentBusiness.BusinessName;
            dataObj.otherData.headerRow2 = this.toolbarTitle + " Summary";

            dataObj.otherData.headerRow3 = 'Period: ' + startDate + ' To ' + endDate;

            console.log(JSON.stringify(dataObj));

            this.myworker.postMessage(dataObj);
        },

        fn_breakDataIntoChunks: function(event){
            // var fileName = this.toolbarTitle + "_Summary"+this.selectionItems.startDate+'_'+this.selectionItems.endDate;
            let downloadTime = new Date();
            // var fileName = this.toolbarTitle + "_Summary_"+downloadTime.getTime();
            var fileName = this.toolbarTitle.replace(/ /g,'') + "-Summary_" + this.$root.fn_getCurrentDateTimeString();
                    
            var chunkcounter = 0;
            if(typeof AndroidRoutingTest !== "undefined" && AndroidRoutingTest !== null){
              console.log('inside');

              //opening file
              let fileId = this.guidWeb();
              AndroidRoutingTest.openFile(fileId, fileName+'.xlsx')

              //writing file
              var chunkSize = event.data.BYTES_PER_ELEMENT * 1000 * 2; //self.$parent.datachunksize //1 byte
              for (var i = 0; i < event.data.length; i += chunkSize) {
                var datachunk = event.data.slice(i, i + chunkSize)
                AndroidRoutingTest.writeFile(fileId, datachunk);
                console.log(++chunkcounter);
              }

              //closing file
              console.log("close");
            //   AndroidRoutingTest.closeFile(fileId);

              //export file
            //   this.fn_exportToExcel(event.data, fileName+".xlsx")

                this.fn_closeAndExportExcelFile(fileId);
            }
        },

        fn_closeAndExportExcelFile: function(fileId){
            let self = this;
            this.closeFile(fileId, {
                onSuccess: function(response){
                    console.log(response);
                    self.showToast('File downloaded at '+ response);
                    self.hideLoading();
                    self.snackbar = true; 
                }, 
                onError: function(error){
                    console.log(error);
                    self.hideLoading();
                    self.showToast('File download failed');
                }
            });
        },

        // fn_exportToExcel: function(data, fileName){
        //     let self = this;
        //     this.exportToExcel(data, fileName,{

        //         onSuccess: function(response){
        //             console.log(response);
        //             self.showToast('File downloaded');
        //             self.hideLoading();
        //             self.snackbar = true; 
        //         }, 
        //         onError: function(error){
        //             console.log(error);
        //             self.showToast('File download failed');
        //         }

        //     });
        // },

        fn_selectPeriod: function(type, month, year){
            if(!type){
                this.fn_openDialogCustomDates();
                return;
            }

          if(type=='M'){
            this.fn_openDialogMonthFilter();
            // this.$refs['ref_dialogMonthFilter'].openDialogWeb();
          }
          else if(type=='Q'){
            this.fn_openDialogQuarterFilter();
            // this.$refs['ref_dialogQuarterFilter'].openDialogWeb();
          }
          else if(type=='FY'){
            this.fn_openDialogFyfilter();
          }
          else{
            this.fn_closeDialog();

            let previousDateSelected = false;

            // Date validation if selected before opening date
            if(type == "previousMonth"){
              let now = new Date();
              let previousMonthDate = new Date(now.getFullYear(), now.getMonth(), 0);
              if(previousMonthDate.getTime() < new Date(this.$root.CurrentBusiness.OpeningDate).getTime()){
                previousDateSelected = true;
              }
            }

            if(type == "previousDate"){
              let now = new Date();
              let yesterday = new Date(now.setDate(now.getDate() - 1));
              if(yesterday.getTime() < new Date(this.$root.CurrentBusiness.OpeningDate).getTime()){
                previousDateSelected = true;
              }
            }

            if(previousDateSelected){
              this.showToast("Not Applicable");
              return;
            }
            // Date validation end if selected before opening date

            let dateObj = this.fn_getTimeSpan(type, month, year);
            
            this.selectionItems.startDate = dateObj.startDate;
            this.selectionItems.endDate = dateObj.endDate;
            
            localStorage.setItem('transaction_filter', JSON.stringify(this.selectionItems));

            // saving filter to local storage
            // let label = typeof(month) == 'object' && month.title ? month.title : '';
            // let localObj = {'startDate':this.selectionItems.startDate, 'endDate':this.selectionItems.endDate, 'label':label, 'type':type, 'month':month, 'year':year};
            let localObj = {'type':type, 'month':month, 'year':year};
            // localStorage.setItem('selected_date_filter', JSON.stringify(localObj));
            let dataObj = {};
            dataObj.LocalKey = 'selected_date_filter';
            dataObj.LocalValue = JSON.stringify(localObj);
            this.$root.fn_saveLocalData(dataObj);
            this.fn_searchItem();
          }
        },

        fn_openDialogMonthFilter: function(){
          this.fn_openDialogWeb('web', 'MonthFilter', 'ref_dialogMonthFilter');
        },

        fn_openDialogQuarterFilter: function(){
          this.fn_openDialogWeb('web', 'QuarterFilter', 'ref_dialogQuarterFilter');
        },

        fn_openDialogFyfilter: function(){
            this.fn_openDialogWeb('web', 'FiscalYearFilter', 'ref_dialogFiscalYearFilter');
        },

        fn_getTimeSpan: function(type, value, year){
            let dateObj = {};

            let minSelectionDate = new Date(this.$root.minDateSelection);
            let currentDate = new Date();
            let currentMonth = currentDate.getMonth() + 1;
            let thisFiscalYear = currentMonth<=3 ? currentDate.getFullYear() : currentDate.getFullYear() + 1;

            if(type=='monthly'){

                let now = null;

                if(value<=3){
                    now = new Date((year+1)+"/"+value);
                }
                else{
                    now = new Date(year+"/"+value);
                }

                let endDate  = new Date(now.getFullYear(), value, 0);
                let startDate = new Date(now.getFullYear(), value-1, 1);

                let sDate = null;
                if(startDate.getTime() > minSelectionDate.getTime()){
                    sDate = startDate;
                }
                else{
                    sDate = minSelectionDate;
                }

                dateObj.startDate = formatDate(sDate);
                dateObj.endDate = formatDate(endDate);
            }
            
            // for current month / this month
            else if(type=='month'){
                let now = new Date();
                let endDate  = new Date(now.getFullYear(), now.getMonth()+1, 0);
                let startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);

                let sDate = null;
                if(startDate.getFullYear() ==  minSelectionDate.getFullYear()){
                    if(startDate.getMonth()+1 > minSelectionDate.getMonth()+1){
                        sDate = startDate;
                    }
                    else{
                        sDate = minSelectionDate
                    }
                }
                else{
                    // sDate = minSelectionDate
                    sDate = startDate
                }

                dateObj.startDate = formatDate(sDate);
                dateObj.endDate = formatDate(endDate);
            }
            else if(type=='previousMonth'){
                let now = new Date();
                let sDate = new Date(now.getFullYear(), now.getMonth()-1, 1);
                let endDate  = new Date(now.getFullYear(), now.getMonth(), 0);
                dateObj.startDate = formatDate(sDate);
                dateObj.endDate = formatDate(endDate);
            }
            else if(type=='quarterly'){
                let now = null;

                if(value<=3){
                    now = new Date((year+1)+"/"+value);
                }
                else{
                    now = new Date(year+"/"+value);
                }

                let quarter = Math.floor((now.getMonth() / 3));
                let firstDate = new Date(now.getFullYear(), quarter * 3, 1);
                let endDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 3, 0);


                if(firstDate.getTime() < minSelectionDate.getTime()){
                    dateObj.startDate = formatDate(minSelectionDate); 
                }
                else{
                    dateObj.startDate = formatDate(firstDate);
                }
                
                dateObj.endDate = formatDate(endDate);
            }
            else if(type=='quarter'){
                let now = new Date();
                let quarter = Math.floor((now.getMonth() / 3));
                let firstDate = new Date(now.getFullYear(), quarter * 3, 1);
                let endDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 3, 0);

                if(firstDate.getTime() < minSelectionDate.getTime()){
                    dateObj.startDate = formatDate(minSelectionDate); 
                }
                else{
                    dateObj.startDate = formatDate(firstDate);
                }
                
                dateObj.endDate = formatDate(endDate);
            }
            else if(type=='year'){
                // let firstday = new Date(this.$root.minDateSelection);
                let endDate = new Date(this.$moment(new Date(thisFiscalYear+"/03/31")).endOf('day'));
                if(this.$root.fn_getMinSelectionDate() < new Date((thisFiscalYear-1)+"/04/01")){
                    dateObj.startDate = formatDate(new Date((thisFiscalYear-1)+"/04/01"));
                }
                else{
                    dateObj.startDate = formatDate(this.$root.fn_getMinSelectionDate());
                }
                // dateObj.startDate = formatDate(this.$root.fn_getMinSelectionDate());
                dateObj.endDate = formatDate(endDate);
            }
            else if(type=='fiscal_year'){
                // let firstday = new Date(this.$root.minDateSelection);
                let endDate = new Date(this.$moment(new Date((year+1)+"/03/31")).endOf('day'));
                // dateObj.startDate = this.formatDate(minSelectionDate);
                let startDate = null;

                let openingYear = new Date(this.$root.minDateSelection).getFullYear();
                let openingMonth = new Date(this.$root.minDateSelection).getMonth() + 1;
                
                let minDateYear = openingMonth < 4 ? openingYear - 1 : openingYear;

                if(minDateYear == year){
                    startDate = new Date(this.$moment(this.$root.minDateSelection));
                }
                else if(minDateYear < year){
                    startDate = new Date(this.$moment(new Date(year+"/04/01")));
                }

                // let minDateYear = new Date(this.$root.minDateSelection).getFullYear();

                // if(minDateYear < year){
                //     startDate = new Date(this.$moment(new Date(year+"/04/01")));
                // }
                // else if(minDateYear == year){
                //     startDate = new Date(this.$moment(this.$root.minDateSelection));
                // }
                // let startDate = new Date(this.$moment(new Date(year+"/03/31")).endOf('day'));
                dateObj.startDate = formatDate(startDate);
                dateObj.endDate = formatDate(endDate);
            }
            else if(type=='alltime'){
                // let firstday = new Date(this.$root.minDateSelection);
                let maxDateYear = new Date(this.$root.maxDateSelection).getFullYear();
                let year = maxDateYear > thisFiscalYear ? maxDateYear : thisFiscalYear;
                let endDate = new Date(this.$moment(new Date(year+"/03/31")).endOf('day'));
                dateObj.startDate = formatDate(minSelectionDate);
                dateObj.endDate = formatDate(endDate);
            }
            else if(type=='endDate'){
                dateObj.startDate = null;
                dateObj.endDate = new Date();
            }
            else if(type=='currentDate'){
                dateObj.startDate = this.$moment(new Date()).startOf('day');
                dateObj.endDate = this.$moment(new Date()).endOf('day');
            }
            else if(type=='previousDate'){
                let now = new Date();
                let yesterday = now.setDate(now.getDate() - 1);
                dateObj.startDate = this.$moment(yesterday).startOf('day');
                dateObj.endDate = this.$moment(yesterday).endOf('day');
            }
            else{
                dateObj.startDate = new Date();
                dateObj.endDate = new Date();
            }

            dateObj.startDate = dateObj.startDate ? this.$root.fn_getLocalDateFormat(dateObj.startDate) : null;
            dateObj.endDate = this.$root.fn_getLocalDateFormat(dateObj.endDate);

            if(new Date(dateObj.endDate) < new Date(this.$root.CurrentBusiness.OpeningDate)){
                this.infoSnackbar = true;
                dateObj.startDate = dateObj.endDate;
            }

            if(type == 'currentDate'){
                this.selectionItems.selectedPeriod = "Today";
            }
            else if(type == 'previousDate'){
                this.selectionItems.selectedPeriod = "Yesterday";
            }
            else if(type == 'month' || type == 'monthly' || type == 'previousMonth'){
                this.selectionItems.selectedPeriod = this.$moment(dateObj.startDate).format('MMM, YYYY');
            }
            else if(type == 'quarter' || type == 'quarterly' || type == 'fiscal_year'){
                this.selectionItems.selectedPeriod = this.$moment(dateObj.startDate).format('MMM') + ' - ' + this.$moment(dateObj.endDate).format('MMM');
            }
            else if(type == 'year'){
                this.selectionItems.selectedPeriod = "This Year";
            }
            else if(type == 'alltime'){
                this.selectionItems.selectedPeriod = "All Time";
            }
            else{
                this.selectionItems.selectedPeriod = null;
            }

            // dateObj.startDate = dateObj.startDate ? this.$root.fn_getLocalDateFormat(dateObj.startDate) : null;
            // dateObj.endDate = this.$root.fn_getLocalDateFormat(dateObj.endDate);

            return dateObj;
        }

    }
    // mounted: function(){
    //     let self = this;
    //     myworker.addEventListener('message', event => {
    //         self.fn_breakDataIntoChunks(event);
    //     });
    // }
}

function formatDate(date_obj){
    return date_obj.getFullYear() + "-" + ("0" + (date_obj.getMonth()+1)).slice(-2) + "-" + ("0" + date_obj.getDate()).slice(-2);
}


// WEBPACK FOOTER //
// ./src/components/transactions/export_excel_mixin.js